import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import Scrim from "./Scrim";
import { useLevel, LevelLayer } from "Trackalyze/context/LevelContext";
import useEscapeKey from "./useEscapeKey";

/**
 * A generic wrapper for modal components (Dialog, SideSheet, Menu, BottomSheet).
 * Handles:
 * - Mount/Unmount CSS animations
 * - Rendering the Scrim background
 * - Calculating appropriate z-indexes via LevelContext
 * - Responding to the Escape key stack
 */
const ModalWrapper = (props) => {
  const [animate, setAnimate] = useState(false);
  const [render, setRender] = useState(false);

  // For BottomSheet, the prop is sometimes used differently, but props.animate
  // represents the "is open" boolean for all components.
  const isOpen = Boolean(props.animate);
  const animationDelay = props.delay || 100;

  const contextLevel = useLevel();
  const finalLevel = props.zIndex || contextLevel;

  useEffect(() => {
    if (!isOpen && animate) {
      close();
    } else if (isOpen) {
      setRender(true);
      window.setTimeout(() => {
        setAnimate(true);
      }, animationDelay);
    }
  }, [isOpen]);

  const close = () => {
    if (props.onClose) {
      props.onClose();
    }
    if (animate) {
      setAnimate(false);
      if (props.onAfterAnimate) {
        window.setTimeout(() => {
          setRender(false);
          props.onAfterAnimate();
        }, 500);
      }
    }
  };

  useEscapeKey(close, render, finalLevel);

  const content = (
    <>
      {!props.noScrim && (
        <Scrim
          zIndex={finalLevel}
          onClick={() => close()}
          animate={animate}
          transparent={props.transparent}
        />
      )}
      {/* 
        Clone the single child element, injecting the calculated 
        CSS animate classes and the correct z-index styles mapping 
      */}
      {React.cloneElement(props.children, {
        className: props.children.props.className,
        "data-animate": animate ? "true" : undefined,
        style: {
          ...props.children.props.style,
          zIndex: finalLevel + 1,
        },
      })}
    </>
  );

  return render
    ? props.portal
      ? ReactDOM.createPortal(content, document.getElementById("app"))
      : content
    : null;
};

// Provides LevelLayer for descendants
export const ModalContent = ({ children }) => {
  return <LevelLayer>{children}</LevelLayer>;
};

export default ModalWrapper;
